function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { AdaptiveListener } from 'xps-react-utils';
import Grid from '../Layout/Grid';
import Row from '../Layout/Row';
import Col from '../Layout/Col';
import Button from '../Button';
import Icon from '../Icon';
import { getValidElementProps } from '../utils/htmlValidProps';

require('xps-style/core/alert.css');

var propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,

  /** main message of the alert */
  message: PropTypes.string,

  /** secondary/detail message of the alert */
  detail: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),

  /** types of alert */
  type: PropTypes.oneOf(['success', 'warning', 'error', 'info', 'neutral']),

  /** display icon before the message */
  icon: PropTypes.string,

  /** alert will take full width of the screen, usually used under the header */
  fullWidth: PropTypes.bool,

  /** callback function to close the alert and/or to do anything else. To close alert set 'showAlert' prop to false.  */
  onClose: PropTypes.func,

  /** show close button on the right side of the alert banner */
  showCloseBtn: PropTypes.bool,

  /** a prop to show/hide the alert */
  showAlert: PropTypes.bool,

  /** array of action objects {name: (string), onClick: (function), disabled: (bool)}, displayed on right side for desktop and below the message for mobile */
  actions: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    disabled: PropTypes.bool
  }))
};
var defaultProps = {
  fullWidth: false,
  showCloseBtn: true,
  showAlert: false
};

var AlertBanner = /*#__PURE__*/function (_Component) {
  _inherits(AlertBanner, _Component);

  var _super = _createSuper(AlertBanner);

  function AlertBanner(props) {
    var _this;

    _classCallCheck(this, AlertBanner);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onMobileSize", function () {
      return _this.updateScreenSize('mobile');
    });

    _defineProperty(_assertThisInitialized(_this), "onTabletSize", function () {
      return _this.updateScreenSize('tablet');
    });

    _defineProperty(_assertThisInitialized(_this), "onDesktopSize", function () {
      return _this.updateScreenSize('desktop');
    });

    _defineProperty(_assertThisInitialized(_this), "updateScreenSize", function (screenSize) {
      return _this.setState({
        screenSize: screenSize
      });
    });

    _this.state = {
      screenSize: ''
    };
    return _this;
  }

  _createClass(AlertBanner, [{
    key: "render",
    value: function render() {
      var _cx;

      var _this$props = this.props,
          className = _this$props.className,
          type = _this$props.type,
          icon = _this$props.icon,
          message = _this$props.message,
          detail = _this$props.detail,
          children = _this$props.children,
          onClose = _this$props.onClose,
          showCloseBtn = _this$props.showCloseBtn,
          fullWidth = _this$props.fullWidth,
          showAlert = _this$props.showAlert,
          actions = _this$props.actions;
      var screenSize = this.state.screenSize;
      var restProps = getValidElementProps('global', this.props);
      var ntClass = cx((_cx = {
        alert: true
      }, _defineProperty(_cx, "alert-skin--".concat(type), true), _defineProperty(_cx, 'alert--full-width', fullWidth), _defineProperty(_cx, 'fontweight-500', true), _defineProperty(_cx, 'display-none', true), _defineProperty(_cx, 'display-block', showAlert), _cx), className);

      var renderActions = function renderActions() {
        if (actions) {
          return /*#__PURE__*/React.createElement("div", {
            className: "alert__actions"
          }, actions.map(function (action) {
            return /*#__PURE__*/React.createElement(Button, {
              key: "action-button-".concat(action.name),
              size: "small",
              kind: "borderless",
              noPadding: true,
              disabled: Boolean(action.disabled),
              onClick: action.onClick,
              className: screenSize === 'desktop' ? 'marginleft-lg' : 'marginright-lg'
            }, action.name);
          }));
        } else {
          return null;
        }
      };

      var renderBanner = /*#__PURE__*/React.createElement(AdaptiveListener, {
        onMobileSize: this.onMobileSize,
        onTabletSize: this.onTabletSize,
        onDesktopSize: this.onDesktopSize
      }, /*#__PURE__*/React.createElement("div", {
        className: "display-flex justify-content-between align-items-center"
      }, icon ? /*#__PURE__*/React.createElement(Icon, {
        name: icon,
        type: type,
        className: "align-self-start marginright-md"
      }) : null, /*#__PURE__*/React.createElement("div", {
        className: "alert__content flex-grow-1 align-self-start width-100p"
      }, screenSize === 'desktop' ? /*#__PURE__*/React.createElement("div", {
        className: "display-flex"
      }, message && /*#__PURE__*/React.createElement("div", {
        className: "marginright-lg flex-shrink-0"
      }, message), detail && /*#__PURE__*/React.createElement("div", {
        className: "fontweight-400 flex-grow-2"
      }, detail)) : /*#__PURE__*/React.createElement("div", {
        className: "inline-block"
      }, message && /*#__PURE__*/React.createElement("div", {
        className: "display-block marginbottom-md"
      }, message), detail && /*#__PURE__*/React.createElement("div", {
        className: "display-block fontweight-400"
      }, detail)), children, screenSize !== 'desktop' && /*#__PURE__*/React.createElement("div", {
        className: "display-block"
      }, renderActions())), screenSize === 'desktop' && /*#__PURE__*/React.createElement(React.Fragment, null, renderActions()), showCloseBtn && /*#__PURE__*/React.createElement(Button, {
        className: "alert__closeBtn",
        size: "small",
        kind: "borderless",
        icon: "only",
        iconName: "close",
        onClick: onClose
      })));
      return /*#__PURE__*/React.createElement("div", _extends({
        role: "alert",
        className: ntClass
      }, restProps), fullWidth ? /*#__PURE__*/React.createElement(Grid, {
        fluid: true
      }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, renderBanner))) : renderBanner);
    }
  }]);

  return AlertBanner;
}(Component);

AlertBanner.propTypes = propTypes;
AlertBanner.defaultProps = defaultProps;
AlertBanner.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "onMobileSize",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "onTabletSize",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "onDesktopSize",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "updateScreenSize",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "screenSize",
      "type": null
    }],
    "returns": null
  }],
  "displayName": "AlertBanner",
  "props": {
    "fullWidth": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "alert will take full width of the screen, usually used under the header"
    },
    "showCloseBtn": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "show close button on the right side of the alert banner"
    },
    "showAlert": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "a prop to show/hide the alert"
    },
    "className": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    },
    "message": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "main message of the alert"
    },
    "detail": {
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "node"
        }]
      },
      "required": false,
      "description": "secondary/detail message of the alert"
    },
    "type": {
      "type": {
        "name": "enum",
        "value": [{
          "value": "'success'",
          "computed": false
        }, {
          "value": "'warning'",
          "computed": false
        }, {
          "value": "'error'",
          "computed": false
        }, {
          "value": "'info'",
          "computed": false
        }, {
          "value": "'neutral'",
          "computed": false
        }]
      },
      "required": false,
      "description": "types of alert"
    },
    "icon": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "display icon before the message"
    },
    "onClose": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "callback function to close the alert and/or to do anything else. To close alert set 'showAlert' prop to false."
    },
    "actions": {
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "shape",
          "value": {
            "name": {
              "name": "string",
              "required": true
            },
            "onClick": {
              "name": "func",
              "required": true
            },
            "disabled": {
              "name": "bool",
              "required": false
            }
          }
        }
      },
      "required": false,
      "description": "array of action objects {name: (string), onClick: (function), disabled: (bool)}, displayed on right side for desktop and below the message for mobile"
    }
  }
};
export default AlertBanner;